const shopDictES = {
  seeProduct: "Ver producto",
  firstBannerText: "El marketplace que siempre te premia",
  secondaryBannerText: "Únete a la Extraconomy",
  secondaryBannerButtonText: "Descubre nuestros planes",
  secondaryBannerText2: "Aumenta tu poder económico",
  searchQueryText: "Has buscado: ",
  subCategoryFilter: "Subcategorías",
  noProductsInCategory: "No tiene productos",
  noProductsInSearch: "No se encontraron productos",
  noSubcategories: "No tiene subcategorías",
  filters: "Filtros",
  downloadable: "Descargable",
  brazil: "Brasil",
  mexico: "México",
  italy: "Italia",
  brl: "BRL",
  mxn: "MXN",
  eur: "EUR",
  usd: "USD",
  gbp: "GBP",
  try: "TRY",
  results: "Resultados",
  result: "Resultado",
  selectStore: "Selecciona una tienda",
  store: "Tienda",
  filter: "Filtrar",
  registerAsCustomerFree: "Regístrate como Customer de forma gratuita",
  register2: "Registrarse",
  selectCategory: "Selecciona el Departamento",
  allDepartments: "Todos los Departamentos",
  departments: "Departamentos",
  discoverAllDepartments: "Descubre todos nuestros departamentos",
  seeBellowAllDepartments:
    "Mira abajo todos nuestros departamentos disponibles en la tienda y filtra productos por el departamento que prefieras",
  linkCopied: "Enlace copiado",
  errorCopyingLink: "Error al copiar el enlace",
  sharedSuccessfully: "Compartido conxito",
  sharingCanceled: "Compartir cancelado",
  errorSharing: "Error al compartir",
  findPartnersNearYou: "Encuentra partners Extraconomy cerca de ti",
  findBusinessSquarePartnersNearYou: "Encuentra partners {subnetName} cerca de ti",
  useOurMap:
    "Descubre empresas, servicios y productos que forman parte de la nueva economía colaborativa. Utiliza el mapa para localizar socios cercanos, aprovechar beneficios y mover la circularidad financiera a tu alrededor.",
  buyLocally:
    "Compra de socios cercanos, fortalece la economía local, acumula recompensas y participa de una red más justa para todos.",
  value: "Valor",
  bank: "Banco",
  transferToThisBank: "Debes realizar la transferencia con los siguientes datos:",
  fringeBenefits: "Flexible Benefits",
  readMore: "Saber más",
  fringeBenefit: "Flexible Benefit",
  myCards: "Tarjeta de fidelidad",
};

export default shopDictES;
